(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation-item.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/react/carousel-navigation-item.js');

'use strict';

const {
  ReactIconButton: IconButton
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const CarouselNavigationItem = _ref => {
  let {
    index,
    isActive,
    onChange,
    size
  } = _ref;
  return React.createElement(IconButton, {
    className: clx('carousel-nav-item', {
      'carousel-nav-item-active': isActive
    }),
    onClick: () => onChange(index)
  }, React.createElement("span", {
    className: clx('carousel-nav-icon', "carousel-nav-icon-".concat(size))
  }));
};
CarouselNavigationItem.defaultProps = {
  size: '300'
};
setGlobal('svs.components.lbUi.carousel.CarouselNavigationItem', CarouselNavigationItem);

 })(window);